"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames = require("classnames");
exports.Icon = function (props) {
    var className = props.className, icon = props.icon;
    var shouldAnimate;
    var iconAttributes;
    var iconToRender = icon;
    if (typeof icon === 'object') {
        var animate = icon.animate, name_1 = icon.name, rest = __rest(icon, ["animate", "name"]);
        shouldAnimate = animate;
        iconToRender = name_1;
        iconAttributes = rest;
    }
    var iconStyles = classnames("p-icon-" + iconToRender, {
        'p-bc-t-primary50': iconToRender === 'spinner',
        animate: shouldAnimate
    }, className);
    return React.createElement("i", __assign({}, iconAttributes, { className: iconStyles }));
};
exports.Icon.displayName = 'Icon';
exports.default = exports.Icon;
//# sourceMappingURL=Icon.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/textbox/build/control/components/Icon.js
// module id = 907
// module chunks = 0